import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';

import './DocsLinks.scss';

const DOC_PAGES = [
  { page: 'mcp', path: '/mcp-docs', label: 'MCP Server documentation' },
  { page: 'teams', path: '/api-reference/teams', label: 'Team Dashboards API documentation' },
  { page: 'streams', path: '/api-reference/streams', label: 'Value Streams API documentation' },
];

const DocsLinks = ({ current }) => (
  <div className='docs_links'>
    <span className='docs_links_label'>Developer documentation</span>
    <div className='docs_links_list'>
      {DOC_PAGES.map(({ page, path, label }) => (page === current ? (
        <span key={page} className='docs_links_tag docs_links_tag_current' aria-current='page'>{label}</span>
      ) : (
        <Link key={page} className='docs_links_tag' to={path}>{label}</Link>
      )))}
    </div>
  </div>
);

DocsLinks.propTypes = {
  current: PropTypes.string.isRequired,
};

export default DocsLinks;
